"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6598],{

/***/ 6598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildAdsEventsJson": function() { return /* binding */ buildAdsEventsJson; },
/* harmony export */   "default": function() { return /* binding */ AdsEvents; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function buildAdsEventsJson(segmentacoes) {
    var result = {};
    if (!segmentacoes || segmentacoes.length === 0) return result;
    segmentacoes.forEach(function(seg) {
        if (!(seg === null || seg === void 0 ? void 0 : seg.chave)) return;
        var values = [];
        var raw = seg.valor;
        if (typeof raw === "string") {
            values.push(raw);
        } else if (Array.isArray(raw)) {
            raw.forEach(function(item) {
                if (typeof item === "string") {
                    values.push(item);
                    return;
                }
                if (Array.isArray(item)) {
                    item.forEach(function(sub) {
                        if (typeof sub === "string") values.push(sub);
                    });
                }
            });
        }
        if (values.length > 0) result[seg.chave] = values;
    });
    return result;
}
function AdsEvents(param) {
    var segmentacoes = param.segmentacoes;
    var json = buildAdsEventsJson(segmentacoes);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        id: "ads-events-json",
        type: "application/json",
        children: JSON.stringify(json)
    });
}


/***/ })

}]);